import React from 'react';
import TranslatedText from '../../../../components/atoms/translated_text';
import BaseModal from '../../../../components/molecules/base_modal';
import { ModalIDs } from '../../../../redux/reducers/gl_modal_reducer/types';

export default function MessageIncomingViewModal() {
  return (
    <BaseModal
      modalID={ModalIDs.MODAL_MESSAGE_INCOMING_VIEW}
      renderHeader={({ header, body }: IModalProps) => (
        <MessageIncomingViewHeader header={header} body={body} />
      )}
      renderContent={({ header, body }: IModalProps) => (
        <React.Fragment>
          <MessageIncomingViewBody header={header} body={body} />
        </React.Fragment>
      )}
    />
  );
}

interface IModalProps {
  header: string;
  body: string;
}

const MessageIncomingViewHeader = ({ header, body }: IModalProps) => {
  return <TranslatedText defaultText={header} />;
};

const MessageIncomingViewBody = ({ header, body }: IModalProps) => {
  return <pre>{body}</pre>;
};
